export default __webpack_public_path__ + "static/media/trash-hover-icon.b2f07787.svg";